import { useEffect, useState } from "react"
import classNames from "classnames"
import { v4 as uuidv4 } from "uuid"

import { ChartEmptyState } from "components/chart/ChartEmptyState"

import styles from "./index.module.scss"

const EMPTY_BARS = [
  { flex: 27, color: "#E2E8F0" },
  { flex: 73, color: "#CBD5E1" },
]

interface Props {
  className?: string
  height?: number
  borderRadius?: number
  items: {
    color: string
    value: number
  }[]
  showEmptyState?: boolean
  emptyMessageFontSize?: number
}

export const BarChart = ({ items, className, height, borderRadius, showEmptyState, emptyMessageFontSize }: Props) => {
  const [isAnimationEnabled, setAnimationEnabled] = useState(false)

  function sumValues(items: Props["items"]): number {
    let total = 0
    for (let i = 0; i < items.length; i++) {
      total += items[i].value
    }
    return total
  }

  const summ = sumValues(items)

  useEffect(() => {
    setAnimationEnabled(true)
  }, [])

  const calculateWidth = (value: number): number => {
    return Number(((value / summ) * 100).toFixed(1))
  }

  if (summ === 0) {
    if (!showEmptyState) {
      return <div className={styles.noDataMessage}>No data</div>
    }

    return (
      <ChartEmptyState
        messageFontSize={emptyMessageFontSize}
        skeleton={
          <div
            className={classNames(styles.barWidgetWrapper, className)}
            style={{ width: "100%", height: height !== undefined ? `${height}px` : undefined }}
          >
            {EMPTY_BARS.map(bar => (
              <div
                key={bar.color}
                className={styles.barWidgetItem}
                style={{
                  flex: bar.flex,
                  backgroundColor: bar.color,
                  borderRadius: borderRadius !== undefined ? `${borderRadius}px` : undefined,
                }}
              />
            ))}
          </div>
        }
      />
    )
  } else {
    return (
      <div
        className={classNames(styles.barWidgetWrapper, className)}
        style={{ height: height !== undefined ? `${height}px` : undefined }}
      >
        {items
          ?.filter(item => item.value > 0)
          .map(item => (
            <div
              className={styles.barWidgetItem}
              key={uuidv4()}
              style={{
                width: isAnimationEnabled ? calculateWidth(item.value) + "%" : "",
                backgroundColor: item.color,
                borderRadius: borderRadius !== undefined ? `${borderRadius}px` : undefined,
              }}
            />
          ))}
      </div>
    )
  }
}
